import React, {useContext, useEffect, useState} from 'react'
import {useHttp} from '../../../hooks/http.hook'
import {AuthContext} from '../../../context/AuthContext'
import {observer} from 'mobx-react'
import TablePage from '../../../components/Pages/TablePage/TablePage'
import TextCell from "../../../components/Pages/TablePage/Table/Cells/NewCells/TextCell/TextCell";
import {formatDate} from "../../../utils/utils";

const PatientPayment = observer((props) => {
    const baseURL = process.env.REACT_APP_BASE_URL
    const {request} = useHttp()
    const {token, userId} = useContext(AuthContext)
    const [data, setData] = useState()
    const [filterOptions, setFilterOptions] = useState('')
    const [pagination, setPagination] = useState({
        limit: 20,
        resultsCount: null,
        offset: 1,
        allPages: 2
    })

    function limitHandler(limit) {
        setPagination({...pagination, limit: limit})
    }

    function offsetHandler(offset) {
        setPagination({...pagination, offset: offset})
    }

    const getData = async (filterData, limit, offset) => {
        const url = `${baseURL}/api/v2/patients/${userId}/payments?${filterData}${'limit=' + limit + '&'}${'offset=' + offset + '&'}`
        const {data, status} = await request(url, 'GET', null, {Authorization: `Bearer ${token}`})

        if (status === 200) {
            setData(data.data)
            data.pagination ? setPagination({...pagination, resultsCount: data.pagination.resultsCount}) : console.log()
        }
    }

    useEffect(() => {
        getData(filterOptions, pagination.limit, pagination.offset)
    }, [filterOptions, pagination.offset, pagination.limit])

    return (<>

            <TablePage pageName={'TablePage'}
                       tableFirstRow={[
                           {title: 'Дата', class: 'custom_date'},
                           {haveSort: false, title: 'Цена'},
                           {title: 'Электронный чек'}
                       ]}
                       tableHaveToShow={[
                           {id: 'payed_date',type: "wrapperCell", typeData: {cell: props => <TextCell text={formatDate(props.cellContent)}/>}, class: 'custom_date'},
                           {id: 'price'},
                           {id: 'bill', type: 'linkButtonCell'}]}
                       breadCrumbsItems={[]}
                       tableStorage={data}
                       tableTitle={''}
                       filterChangeURL={e => setFilterOptions(e)}
                       showCountChanger={e => limitHandler(e)}
                       setActualPage={e => offsetHandler(e)}
                       filterFieldsConf={{date: true}}
                       filterBarButtons={{
                           downloadTemplate: {
                               show: false,
                               url: '/'
                           }
                       }}
                       pagination={pagination}
                       addOrg={props.addOrg}
                       exportTemplateButtons={{export: false, registry: false}}
            />
            <style jsx>
                {`
                  .custom_date {
                    width: 150px !important;
                    display: flex !important;
                    justify-content: center !important;
                  }

                `}
            </style>
        </>

    )


})

export default PatientPayment
